// Shared react-select style objects used across portal forms.
// Lifted verbatim from the inline copies in StartRemoteDebug.js / UpdateSessionComponent.js
// so new screens (e.g. Real-Time Device Management) can reuse them instead of
// re-declaring a third copy. Existing diagnostics screens are intentionally left
// on their local copies for now to avoid touching frozen behavior.

// Portal brand primary — kept as a JS constant because CSS vars are not readable in JS style objects.
const BRAND_PRIMARY = '#3253DC';
const BRAND_PRIMARY_SOFT = '#eff6ff';

export const selectStyles = {
  control: (base) => ({
    ...base,
    minHeight: '38px',
    height: '38px',
    borderColor: 'rgb(103, 114, 132)',
  }),
  valueContainer: (base) => ({
    ...base,
    height: '38px',
    padding: '0 8px',
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'nowrap',
  }),
  indicatorsContainer: (base) => ({
    ...base,
    height: '38px',
  }),
  placeholder: (base) => ({
    ...base,
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    margin: 0,
  }),
  singleValue: (base) => ({
    ...base,
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    margin: 0,
  }),
  input: (base) => ({
    ...base,
    margin: 0,
    padding: 0,
  }),
  option: (base, state) => ({
    ...base,
    fontSize: '14px',
    color: state.isSelected ? 'white' : 'rgba(0, 0, 0, 0.85)',
    padding: '8px 12px',
    backgroundColor: state.isSelected
      ? BRAND_PRIMARY
      : state.isFocused
      ? BRAND_PRIMARY_SOFT
      : 'white',
  }),
};

export const selectStylesMulti = {
  control: (base) => ({
    ...base,
    minHeight: '38px',
    height: '38px',
    borderColor: 'rgb(103, 114, 132)',
  }),
  valueContainer: (base) => ({
    ...base,
    height: '38px',
    padding: '0 8px',
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'nowrap',
    overflow: 'hidden',
  }),
  indicatorsContainer: (base) => ({
    ...base,
    height: '38px',
  }),
  option: (base, state) => ({
    ...base,
    fontSize: '14px',
    color: state.isSelected ? 'white' : 'rgba(0, 0, 0, 0.85)',
    padding: '8px 12px',
    backgroundColor: state.isSelected
      ? BRAND_PRIMARY
      : state.isFocused
      ? BRAND_PRIMARY_SOFT
      : 'white',
  }),
};
